(function () {
  "use strict";

  /* Densities are for settled, dry material, lb per cubic foot.
     Sources: university extension bulk-density tables + supplier spec sheets. */
  var MATERIALS = [
    { id: "shredded_hardwood", name: "Shredded hardwood / bark mulch", density: 20, use: "Beds, borders, general landscaping" },
    { id: "wood_chips",        name: "Wood chips / arborist chips",    density: 18, use: "Paths, around trees, orchards" },
    { id: "cedar",             name: "Cedar or cypress mulch",         density: 17, use: "Beds where you want slow breakdown" },
    { id: "pine_bark",         name: "Pine bark nuggets",              density: 13, use: "Shrub beds, slopes (nuggets float in heavy rain)" },
    { id: "pine_straw",        name: "Pine straw",                     density: 4,  use: "Acid-loving plants, slopes, large beds" },
    { id: "straw",             name: "Straw",                          density: 4,  use: "Vegetable beds, protecting new grass seed" },
    { id: "compost",           name: "Compost used as mulch",          density: 40, use: "Vegetable beds, feeding the soil" },
    { id: "leaf_mould",        name: "Shredded leaves / leaf mould",   density: 10, use: "Free autumn mulch for any bed" },
    { id: "rubber",            name: "Rubber mulch",                   density: 45, use: "Play areas, permanent paths" },
    { id: "ewf",               name: "Engineered wood fiber (EWF)",    density: 18, use: "Playgrounds needing certified fall protection" },
    { id: "custom",            name: "Custom density...",              density: null, use: "" }
  ];

  var DEPTH_NOTES = {
    1: "A top-up depth only — too thin to hold moisture or block weeds on its own.",
    2: "Refresh depth for a bed that already has mulch under it.",
    3: "The standard depth for most flower and shrub beds.",
    4: "Good for weed suppression on a new bed. Do not exceed 4\" over roots.",
    6: "Deep fill. Fine for paths, too deep for planted beds.",
    9: "Playground depth — check the fall height your equipment needs."
  };

  var $ = function (id) { return document.getElementById(id); };
  var shape = "rectangle";
  var matSel = $("mc-mat");

  MATERIALS.forEach(function (m) {
    var o = document.createElement("option");
    o.value = m.id; o.textContent = m.name; matSel.appendChild(o);
  });

  function matById(id) {
    for (var i = 0; i < MATERIALS.length; i++) if (MATERIALS[i].id === id) return MATERIALS[i];
    return MATERIALS[0];
  }

  function refreshMatUse() {
    var m = matById(matSel.value);
    $("mc-mat-use").textContent = m.use ? "Best for: " + m.use : "";
    $("f-density").classList.toggle("hidden", m.id !== "custom");
  }
  matSel.addEventListener("change", refreshMatUse);
  refreshMatUse();

  /* ---- shape switching ---- */
  var shapeBtns = Array.prototype.slice.call(document.querySelectorAll("#mc-shapes .shape"));
  function selectShape(btn) {
    shape = btn.getAttribute("data-shape");
    shapeBtns.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle("active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    ["rectangle", "circle", "ring", "area"].forEach(function (p) {
      var on = p === shape;
      document.querySelectorAll('[data-pane="' + p + '"]').forEach(function (el) {
        el.classList.toggle("hidden", !on);
      });
    });
  }
  shapeBtns.forEach(function (btn) {
    btn.addEventListener("click", function () { selectShape(btn); });
  });

  /* ---- depth chips ---- */
  document.querySelectorAll("#mc-depth-chips button").forEach(function (chip) {
    chip.addEventListener("click", function () {
      $("mc-depth").value = chip.getAttribute("data-depth");
      $("mc-depth-u").value = "in";
      document.querySelectorAll("#mc-depth-chips button").forEach(function (b) {
        b.classList.toggle("on", b === chip);
      });
      refreshDepthNote();
    });
  });

  var TO_FT = { in: 1 / 12, ft: 1, yd: 3 };

  function val(id) {
    var el = $(id); if (!el) return 0;
    var v = parseFloat(el.value);
    return isNaN(v) ? 0 : v;
  }

  function refreshDepthNote() {
    var d = val("mc-depth") * TO_FT[$("mc-depth-u").value] * 12; // inches
    var note = "";
    if (d > 0) {
      if (d < 1.5) note = DEPTH_NOTES[1];
      else if (d < 2.5) note = DEPTH_NOTES[2];
      else if (d < 3.5) note = DEPTH_NOTES[3];
      else if (d < 5) note = DEPTH_NOTES[4];
      else if (d < 8) note = DEPTH_NOTES[6];
      else note = DEPTH_NOTES[9];
    }
    $("mc-depth-note").textContent = note;
  }
  $("mc-depth").addEventListener("input", function () {
    var v = $("mc-depth").value;
    document.querySelectorAll("#mc-depth-chips button").forEach(function (b) {
      b.classList.toggle("on", b.getAttribute("data-depth") === v && $("mc-depth-u").value === "in");
    });
    refreshDepthNote();
  });
  $("mc-depth-u").addEventListener("change", refreshDepthNote);
  refreshDepthNote();
  document.querySelectorAll("#mc-depth-chips button").forEach(function (b) {
    if (b.getAttribute("data-depth") === "3") b.classList.add("on");
  });

  function areaSqFt() {
    if (shape === "rectangle") {
      return val("mc-len") * TO_FT[$("mc-len-u").value] * (val("mc-wid") * TO_FT[$("mc-wid-u").value]);
    }
    if (shape === "circle") {
      var r = val("mc-dia") * TO_FT[$("mc-dia-u").value] / 2;
      return Math.PI * r * r;
    }
    if (shape === "ring") {
      var ro = val("mc-ring-out") * TO_FT[$("mc-ring-out-u").value] / 2;
      var ri = val("mc-ring-in") * TO_FT[$("mc-ring-in-u").value] / 2;
      if (ri >= ro) return -1; // signals an input error
      return Math.PI * (ro * ro - ri * ri);
    }
    var a = val("mc-area");
    return $("mc-area-u").value === "sqyd" ? a * 9 : a;
  }

  function fmt(n, dp) {
    dp = dp == null ? 2 : dp;
    if (!isFinite(n)) n = 0;
    return n.toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }

  function fmtQty(n, dp) {
    if (!isFinite(n) || n <= 0) return fmt(0, dp);
    var min = Math.pow(10, -dp);
    return n < min ? "<" + min.toFixed(dp) : fmt(n, dp);
  }

  function ceilQty(n) {
    return Math.ceil(n - 1e-9);
  }

  function calculate() {
    var area = areaSqFt();
    var depthFt = val("mc-depth") * TO_FT[$("mc-depth-u").value];
    var err = $("mc-error");

    if (area < 0) {
      err.textContent = "The inner diameter of a tree ring must be smaller than the outer diameter.";
      err.classList.add("show");
      $("mc-results").classList.remove("show");
      return;
    }
    if (area <= 0 || depthFt <= 0) {
      err.textContent = "Please enter your bed measurements and a mulch depth.";
      err.classList.add("show");
      $("mc-results").classList.remove("show");
      return;
    }
    err.classList.remove("show");

    var m = matById(matSel.value);
    var density = m.id === "custom" ? val("mc-density") : m.density;
    if (density <= 0) density = 20;

    var ft3 = area * depthFt;
    if ($("mc-overage").checked) ft3 *= 1.1;

    var yd3 = ft3 / 27;
    var lb = ft3 * density;
    var tons = lb / 2000;

    var bagSize = val("mc-bag");
    if (bagSize <= 0) bagSize = 2;
    // ceilQty, not Math.ceil: the 10% buffer is a binary float, so an exact result
    // arrives as 110.00000000000001 and rounds up one bag too many. Measured
    // 2026-09-16: 3,895 such inputs at the 2 cu ft default, all with the buffer on
    // (it is on by default) - e.g. 10 x 30 ft at 4 in printed 56 bags instead of 55.
    var bags = ceilQty(ft3 / bagSize);

    var price = val("mc-price");
    var priceUnit = $("mc-price-u").value;
    var costable = price > 0;
    var cost = 0;
    if (costable) {
      if (priceUnit === "yd3") cost = yd3 * price;
      else if (priceUnit === "bag") cost = bags * price;
      else if (priceUnit === "sqft") cost = area * price;
    }

    $("mc-r-yd3").textContent = fmtQty(yd3, 2);
    $("mc-r-ft3").textContent = fmtQty(ft3, 1) + " cubic feet";
    $("mc-r-bags").textContent = fmt(bags, 0);
    $("mc-r-bags-lbl").textContent = "bags at " + fmt(bagSize, bagSize % 1 ? 1 : 0) + " cu ft";
    $("mc-r-weight").textContent = lb < 2000 ? fmtQty(lb, 0) : fmtQty(tons, 2);
    $("mc-r-weight-lbl").textContent = lb < 2000 ? "pounds, dry" : "US tons, dry";
    $("mc-r-area").textContent = fmtQty(area, 0);

    var costTile = $("mc-r-cost-tile");
    if (costable) {
      costTile.classList.remove("hidden");
      $("mc-r-cost").textContent = "$" + fmt(cost, 2);
      $("mc-r-cost-lbl").textContent = "at $" + fmt(price, 2) + "/" +
        (priceUnit === "yd3" ? "yd³" : priceUnit === "sqft" ? "sq ft installed" : "bag");
    } else {
      costTile.classList.add("hidden");
    }

    /* bulk vs bagged verdict — the single most-asked mulch question */
    var verdict;
    if (yd3 < 0.5) {
      verdict = "<strong>Buy bags.</strong> At " + fmtQty(yd3, 2) + " cubic yards this is a small job — " +
        bags + " bags is easier to handle than arranging a bulk delivery, and you will not be left with a pile.";
    } else if (yd3 < 1) {
      verdict = "<strong>Either works.</strong> " + bags + " bags will do it, but you are close to the point where " +
        "bulk becomes cheaper per cubic foot. Compare your local bulk price before you load the car.";
    } else {
      verdict = "<strong>Buy bulk.</strong> " + fmtQty(yd3, 2) + " cubic yards is roughly " + bags +
        " bags — at that volume bulk delivery is normally cheaper per cubic foot, and it saves you a lot of lifting and plastic.";
    }
    $("mc-r-verdict").innerHTML = verdict;

    $("mc-r-note").textContent = "Based on " + (m.id === "custom" ? "your custom density" : m.name.toLowerCase()) +
      " at about " + fmt(density, 0) + " lb/ft³ dry — wet mulch weighs 30–50% more." +
      ($("mc-overage").checked ? " Includes a 10% buffer for settling and spillage." : " No overage buffer included.") +
      " Mulch density varies with material and moisture — confirm before ordering bulk.";

    var res = $("mc-results");
    res.classList.add("show");
    res.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  $("mc-calc").addEventListener("click", calculate);

  $("mc-reset").addEventListener("click", function () {
    ["mc-len", "mc-wid", "mc-dia", "mc-ring-out", "mc-ring-in", "mc-area", "mc-price", "mc-density"]
      .forEach(function (id) { if ($(id)) $(id).value = ""; });
    $("mc-depth").value = "3";
    $("mc-depth-u").value = "in";
    $("mc-bag").value = "2";
    $("mc-overage").checked = true;
    document.querySelectorAll("#mc-depth-chips button").forEach(function (b) {
      b.classList.toggle("on", b.getAttribute("data-depth") === "3");
    });
    $("mc-results").classList.remove("show");
    $("mc-error").classList.remove("show");
    refreshDepthNote();
  });

  document.querySelectorAll("#mulch-tool input").forEach(function (inp) {
    inp.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); calculate(); }
    });
  });
})();
